import { render, staticRenderFns } from "./DiscoveryMatching.vue?vue&type=template&id=e1ed5f00"
import script from "./DiscoveryMatching.vue?vue&type=script&lang=js"
export * from "./DiscoveryMatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports